/* export class Modifier {
  orgUuid: string;
  name: string;
  price: number;
  priceAddon: number;
  checked: boolean;
} */
import {ModifierGroup} from './modifierGroup';
import {SquareMoney} from "./squareMoney";

//This is a square model but didnt delete after merge into clover.
export class Modifier {

  id: string;
  name: string;
  alternateName: string;
  amount: number;
  modifier: Modifier;
  quantitySold: number; // This is only used in reports. The count of how many of these modifiers that were sold
  refunded: boolean;

  //square properties
  uid: string;
  base_price_money: SquareMoney;
  total_price_money: SquareMoney;
  catalog_object_id: string;
  quantity: string;

  //Square Properties
  price: number;
  modifierGroup: ModifierGroup;
  orgUuid: string;
  priceAddon: number;
  checked: boolean;

  //square
  selected: boolean;
}
